import { DesignTokenTypedData, ThemeOverrideOrigin, } from "@supernova-studio/model";
import { z } from "zod";
//
// Read
//
export const DTOThemeOverride = DesignTokenTypedData.and(z.object({
    tokenPersistentId: z.string(),
    origin: ThemeOverrideOrigin.optional(),
}));
//
// Write
//
export const DTOThemeOverrideCreatePayload = DesignTokenTypedData.and(z.object({
    tokenPersistentId: z.string(),
}));
